import React from "react";
import {useState} from "react";
import style from "./style.module.css";
import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import {Spinner} from "react-bootstrap";
import { useEffect } from "react";

export default function History() {
  let idHistory = 1;

  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);

  const [title, setTitle] = React.useState("");
  const [text, setText] = React.useState("");
  const [image, setImage] = React.useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [mission, setMission] = React.useState("");
  const [values, setValues] = React.useState("");
  const [vision, setVision] = React.useState("");
  const [number_animals, setNumberAnimals] = React.useState("");
  const [number_rescues, setNumberRescues] = React.useState("");
  const [number_available, setNumberVolunteers] = React.useState("");

  const [currentImage, setCurrentImage] = useState(null);

  const buildFormData = () =>{
    const formData = new FormData();
    if(title!=undefined){

      formData.append("title", title)
    }
    if(text!=undefined){

      formData.append("text", text)
    }
    if(mission!=undefined){

      formData.append("mission", mission)
    }
    if(vision!=undefined){

      formData.append("vision", vision)
    }
    
    if(values!=undefined){
      formData.append("values", values)
    }
    if(number_animals!=undefined){

      formData.append("number_animals", number_animals)
    }
    if(number_rescues!=undefined){

      formData.append("number_rescues", number_rescues)
    }
    if(number_available!=undefined){

      formData.append("number_available", number_available)
    }
    
    if(idHistory){
      formData.append('_method', 'PUT')
      if (updateImage) {
        formData.append("image", updateImage);
      }
    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  const submitData = () => {
    setSaving(true);
    BaseApi.post(`/historia/${idHistory}`, formData).then(res => {
      setSaving(false);
      toast.success('História salva com sucesso!');
    }).then(() => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Dados salvos com sucesso!',
        showConfirmButton: false,
        timer: 1500
      })
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
      setSaving(false);
    })
  }

  const handleChangeImage = (e) => {
    const selectedImage = e.target.files[0];
    if (idHistory){
        if (selectedImage)  {
            setUpdateImage(selectedImage);
            setCurrentImage(selectedImage);
        }
    }
    else {
        if (selectedImage)  {
            setImage(selectedImage);
            setCurrentImage(selectedImage);
        }
    }
};

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/historia`).then(res => {
      let data = res.data;
      setTitle(data.title);
      setText(data.text);
      setImage(data.image);
      setCurrentImage(data.image);
      setMission(data.mission);
      setVision(data.vision);
      setValues(data.values);
      setNumberAnimals(data.number_animals);
      setNumberVolunteers(data.number_available);
      setNumberRescues(data.number_rescues);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este lead ou não foi encontrado.', 'error');
    })
  }

  useEffect(() => {
      requestData();
  }, [])

  return(
    <>
    <div className="d-flex flex-column">
      <div className="d-flex flex-column flex-nd-row pb-4">
        <div className={style.history}>
          <h1>História</h1>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-center">
        {isLoading && (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </div>
        <>
        {!isLoading && (
          <div className="row">
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="title">Título </label> 
              <input
                type="text"
                className="form-control"
                id="title"
                placeholder="Insira o titulo"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="text">Texto </label> 
              <div>
                <textarea 
                  name="text" 
                  id="text" 
                  cols="30" 
                  rows="10"
                  className="form-control"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="mission">Missão </label> 
              <div>
                <textarea 
                  name="text" 
                  id="mission" 
                  cols="30" 
                  rows="5"
                  className="form-control"
                  value={mission}
                  onChange={(e) => setMission(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="vision">Visão </label> 
              <div>
                <textarea 
                  name="text" 
                  id="vision" 
                  cols="30" 
                  rows="5"
                  className="form-control"
                  value={vision}
                  onChange={(e) => setVision(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="values">Valores </label> 
              <div>
                <textarea 
                  name="text" 
                  id="values" 
                  cols="30" 
                  rows="5"
                  className="form-control"
                  value={values}
                  onChange={(e) => setValues(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="number_animals">Números de animais que já passaram pelo abrigo </label> 
              <input
                type="number"
                className="form-control"
                id="number_animals"
                placeholder="Insira a quantidade de animais"
                value={number_animals}
                onChange={(e) => setNumberAnimals(e.target.value)}
              />
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="number_available">Números de animais disponíveis para adoção</label>
              <input
                type="number"
                className="form-control"
                id="number_available"
                placeholder="Insira a quantidade de animais disponiveis para adoção"
                value={number_available}
                onChange={(e) => setNumberVolunteers(e.target.value)}
              />
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="number_rescues">Números de animais resgatados </label>
              <input
                type="number"
                className="form-control"
                id="number_rescues"
                placeholder="Insira a quantidade de animais resgatados"
                value={number_rescues}
                onChange={(e) => setNumberRescues(e.target.value)}
              />
            </div>
            <div className="form-group mb-3">
              <label className={style.required} htmlFor="image">Imagem </label>

              <input type="file" accept="image/*"
                className="form-control"
                onChange={handleChangeImage} 
              />
                  
              {History.id ? (
              <div className="d-flex justify-content-center align-items-center mt-2">
                <img
                  src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage}
                  alt="imagem"
                  style={{ minWidth: 250, width: 350, objectFit: 'cover' }}
                />
              </div>
              ) : 
                null
              }

              {currentImage && !History.id && (
                <div className="d-flex justify-content-center align-items-center mt-2">
                  {History.id ? <img src={currentImage} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                    : <img src={currentImage instanceof File ? URL.createObjectURL(currentImage) : currentImage} alt="imagem" style={{minWidth: 250, width: 350, objectFit: "cover"}}/>
                  }
                </div>
              )}
            </div>

            <button
              loading={isSaving}
              onClick={onSave}
              className="btn btn-success text-white"
            >
            Salvar
            </button>    
          </div>
        )} 
        </>
    </div>
    </>
  )
}